/**
 * Created by r4zi4l on 06.04.2021
 */

const ThirdElementWindow = CleverappsWindow.extend({
    onWindowLoaded: function (thirdElement) {
        this.thirdElement = thirdElement;

        this._super({
            title: Messages.get("ThirdElementWindow.title"),
            name: "ThirdElementWindow",
            content: this.createContent(),
            closeButton: true,
            notCloseByTouchInShadow: true,
            closeButtonDelay: true,
            openSound: bundles.thirdelement.urls.thirdelement_window_effect
        });
    },

    getPerson: function () {
        return cleverapps.persons.choose("seller", "worker");
    },

    createContent: function () {
        const styles = cleverapps.styles.ThirdElementWindow;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize(styles);

        const infoBlock = this.createInfoBlock();
        infoBlock.setAnchorPoint(0.5, 0.5);
        infoBlock.setAlignment(styles.infoBlock);
        content.addChild(infoBlock);

        const buttons = this.createButtons();
        buttons.setAnchorPoint(0.5, 0.5);
        buttons.setAlignment(styles.buttons);
        content.addChild(buttons);

        const title = cleverapps.UI.generateOnlyText(Messages.get("ThirdElementWindow.text"), cleverapps.styles.FONTS.THIRD_ELEMENT_WINDOW_TEXT);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setDimensions(styles.title.width, 0);
        title.fitTo(undefined, styles.title.height);
        title.setAnchorPoint(0.5, 0.5);
        title.setAlignment(styles.title);
        content.addChild(title);

        return content;
    },

    createInfoBlock: function () {
        const styles = cleverapps.styles.ThirdElementWindow.infoBlock;

        const background = cleverapps.UI.createScale9Sprite(bundles.merge.frames.icon_background);
        background.setContentSize2(styles);

        if (this.thirdElement.getTimeLeft()) {
            const timer = this.createTimer();
            timer.setAnchorPoint(0.5, 0.5);
            timer.setAlignment(styles.timer);
            background.addChild(timer);
        }

        const icon = new UnitOnCell(this.thirdElement.prize);
        icon.setAnchorPoint(0.5, 0.5);
        icon.setScale(styles.icon.scale);
        icon.setAlignment(styles.icon);
        background.addChild(icon);

        return background;
    },

    createTimer: function () {
        const styles = cleverapps.styles.ThirdElementWindow.infoBlock.timer;

        const countdown = new Timer(this.thirdElement.getTimeLeft());
        countdown.setAnchorPoint(0.5, 0.5);
        countdown.setAlignment(styles);

        const text = cleverapps.UI.generateOnlyText(Messages.get("ThirdElementWindow.timer"), cleverapps.styles.FONTS.THIRD_ELEMENT_WINDOW_TITLE_TEXT);

        text.setDimensions(styles.textWidth, 0);
        text.fitTo(undefined, styles.textHeight);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        return new cleverapps.Layout([text, countdown], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createButtons: function () {
        const styles = cleverapps.styles.ThirdElementWindow.buttons;

        const buyButton = this.buyButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: this.getPriceText(),
            textOff: Messages.get("ThirdElementWindow.timeIsOver"),
            onClicked: this.tryBuy.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_blue
        });

        const passButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("ThirdElementWindow.pass"),
            onClicked: this.tryPass.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_red
        });

        return new cleverapps.Layout([buyButton, passButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    getPriceText: function () {
        const product = this.thirdElement.getProduct();
        return product ? product.getCurrentPrice() : `$$${this.thirdElement.price}`;
    },

    tryBuy: function () {
        this.thirdElement.buy((success) => {
            if (success) {
                this.close();
            } else {
                this.buyButton.setString(this.getPriceText());
            }
        });
    },

    tryPass: function () {
        this.close();
        this.thirdElement.reject();
    },

    getPreferredBundles: function () {
        return ["game"];
    },

    listBundles: function () {
        return ["thirdelementwindow"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    THIRD_ELEMENT_WINDOW_TITLE_TEXT: {
        size: 55,
        color: cleverapps.styles.COLORS.YELLOW_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    THIRD_ELEMENT_WINDOW_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.ThirdElementWindow = {
    width: 830,
    height: 670,

    infoBlock: {
        width: 830,
        height: 340,
        x: { align: "center" },
        y: { align: "top" },

        icon: {
            x: { align: "right", dx: -100 },
            y: { align: "center", dy: 5 },
            scale: 1.2
        },

        timer: {
            width: 280,
            height: 54,
            x: { align: "left", dx: 110 },
            y: { align: "center", dy: 10 },
            margin: 20,

            textWidth: 385,
            textHeight: 70
        }
    },

    title: {
        width: 600,
        height: 120,
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 185 }
    },

    buttons: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 15 },
        margin: 52,
        button: {
            width: 360,
            height: 110
        }
    }
};
